import React, { Component } from 'react';
import {DOMAIN, WP_SUB_DIRECTORY} from './consts.js';
import 'font-awesome/css/font-awesome.min.css';

class Footer extends Component {


  render() {


    return (
      <div className="footer">
        <div className="row footer-widget-row">
          <div className="col-lg-4 col-md-4 col-sm-12">
          <h4>YHTEYSTIEDOT</h4>
          <p>PÖ.fi / Janne Peltola<br></br>
          Yläneen Rakennuskeskus Oy<br></br>
          Haverintie 1A<br></br>
          21900 Yläne.</p>

          <p>Sähköposti: <a href="mailto:asiakaspalvelu@yrk.fi" target="_blank" rel="noopener">asiakaspalvelu@yrk.fi</a><br></br>

          Puhelin: <a href="tel:+35810 339 3373">010 339 3373</a></p>
          </div>


          <div className="col-lg-4 col-md-4 col-sm-12">
          <h4>PÖ.FI</h4>


            <p><a href="/">Vertaa hinnat ja tilaa</a></p>
            <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/`}>Lämmitysöljy</a></p>
            <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/polttooljy`}>Moottoripolttoöjy</a></p>
            <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/miksipofi`}>Miksi Pö.fi</a></p>
            <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/usein-kysyttya`}>Usein kysyttyä</a></p>
            <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/Yhteystiedot`}>Yhteystiedot</a></p>


          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
          <h4>TIETOA</h4>
          <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/toimitusehdot`}>Toimitusehdot</a></p>
          <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/purkuohjeet`}>Öljypurkujen turvallisuusohjeet</a></p>
          <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/sakaraliittimet`}>Tiedote: Nokkavipuliittimet</a></p>
          <p><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/tietosuojaseloste`}>Tietosuoja</a></p>
          </div>
        </div>
        <div className="row footer-bottom-row">
          <div className="col-lg-5 col-md-5 col-sm-12">
          <span>©2019 Janne Peltola. Kaikki oikeudet pidätetään.</span>
          </div>
          <div className="col-lg-7 col-md-7 col-sm-12">
            <ul className="social">
					        <li>
                    <a target="_blank" href="https://www.facebook.com/omakylakauppa/"><i className="fa fa-facebook"></i></a>
                  </li>
                  <li>
                    <a target="_blank" href="tel:+358504432441"><i className="fa fa-phone"></i></a>
                  </li>
                  <li>
                    <a target="_blank" href="mailto:myynti@yrk.fi"><i className="fa fa-envelope"></i></a>
                  </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
